module.exports = __webpack_public_path__ + "img/pin_substitution_purple.3e5fb084.svg";